var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Animated, Pressable, View } from 'react-native';
import { getSingleDotIndictorStyle } from './DotIndicatorStyles';
import { getAnimatedWidth, getAutoPlayAnimation, getDotAnimation } from './DotIndicatorUtils';
import { RED_500 } from '../../../../constants/colors';
import { checkIsPlatform } from '../../../../utils';
var AnimatedPressable = Animated.createAnimatedComponent(Pressable);
var SingleDotIndicator = props => {
  var index = props.index,
    inActiveSize = props.inActiveSize,
    autoAnimate = props.autoAnimate,
    activeIndex = props.activeIndex,
    _props$isPressable = props.isPressable,
    isPressable = _props$isPressable === void 0 ? true : _props$isPressable,
    goToIndex = props.goToIndex,
    dotStyle = props.dotStyle;
  var isActive = activeIndex === index;
  var animatedWidthSize = inActiveSize * 4;
  var endWidth = isActive && autoAnimate ? animatedWidthSize : inActiveSize;
  var animatedWidth = useRef(new Animated.Value(endWidth)).current;
  useEffect(() => {
    if (autoAnimate) {
      getAnimatedWidth(animatedWidth, endWidth);
    }
  }, [isActive]);
  var Wrapper = isPressable ? AnimatedPressable : Animated.View;
  var singleDotIndicatorStyles = getSingleDotIndictorStyle(props, isActive);
  var handleIndicatorPress = () => {
    if (isPressable) {
      return () => {
        goToIndex === null || goToIndex === void 0 ? void 0 : goToIndex(index);
      };
    }
  };
  return _jsx(Wrapper, {
    style: [singleDotIndicatorStyles.dotContainer, {
      width: animatedWidth
    }, dotStyle],
    onPress: handleIndicatorPress()
  });
};
export var DotIndicator = props => {
  var count = props.count,
    activeIndex = props.activeIndex,
    _props$activeSize = props.activeSize,
    activeSize = _props$activeSize === void 0 ? 6 : _props$activeSize,
    _props$inActiveSize = props.inActiveSize,
    inActiveSize = _props$inActiveSize === void 0 ? 8 : _props$inActiveSize,
    _props$horizontalSpac = props.horizontalSpacing,
    horizontalSpacing = _props$horizontalSpac === void 0 ? 4 : _props$horizontalSpac,
    _props$activeColor = props.activeColor,
    activeColor = _props$activeColor === void 0 ? RED_500 : _props$activeColor,
    _props$animationDurat = props.animationDuration,
    animationDuration = _props$animationDurat === void 0 ? 400 : _props$animationDurat,
    autoPlay = props.autoPlay,
    autoPlayTransitionSpeed = props.autoPlayTransitionSpeed,
    activeIndicatorColor = props.activeIndicatorColor,
    inActiveBorderColor = props.inActiveBorderColor,
    restProps = __rest(props, ["count", "activeIndex", "activeSize", "inActiveSize", "horizontalSpacing", "activeColor", "animationDuration", "autoPlay", "autoPlayTransitionSpeed", "activeIndicatorColor", "inActiveBorderColor"]);
  var autoAnimate = autoPlayTransitionSpeed && autoPlay;
  var animatedDotSize = autoAnimate ? inActiveSize : activeSize;
  var animatedLeft = useRef(new Animated.Value(1)).current;
  var animatedRight = useRef(new Animated.Value(0)).current;
  var animatedDotScaling = useRef(new Animated.Value(1)).current;
  var prevIndex = useRef(activeIndex);
  var singleDotIndictorStyle = getSingleDotIndictorStyle(props);
  useEffect(() => {
    var oldIndex = prevIndex.current;
    var args = {
      activeIndex,
      animatedLeft,
      animatedRight,
      animationDuration,
      animatedDotSize,
      horizontalSpacing,
      autoPlayTransitionSpeed,
      oldIndex,
      inActiveSize,
      animatedDotScaling
    };
    autoAnimate ? getAutoPlayAnimation(args) : getDotAnimation(args);
    prevIndex.current = activeIndex;
  }, [activeIndex]);
  return _jsx(_Fragment, {
    children: _jsxs(View, Object.assign({
      style: singleDotIndictorStyle.container
    }, checkIsPlatform('web') && {
      'aria-hidden': true
    }, {
      children: [Array.from({
        length: count
      }, (_, index) => _jsx(SingleDotIndicator, Object.assign({
        index: index,
        activeIndex: activeIndex,
        activeSize: activeSize,
        inActiveSize: inActiveSize,
        horizontalSpacing: horizontalSpacing,
        autoAnimate: autoAnimate,
        inActiveBorderColor: inActiveBorderColor
      }, restProps), "carousel_indicator_dot_" + index)), _jsx(View, Object.assign({
        pointerEvents: "none",
        style: singleDotIndictorStyle.animatedView
      }, {
        children: _jsx(Animated.View, {
          style: {
            height: activeSize,
            width: activeSize,
            borderRadius: 2,
            backgroundColor: activeIndicatorColor || activeColor,
            transform: [{
              translateX: animatedRight
            }, {
              scaleX: animatedDotScaling
            }]
          }
        })
      }))]
    }))
  });
};